import wlWorkflow from "../package/Workflow/nodeWrap.vue"; // 引入封装好的组件

const coms = [wlWorkflow]; // 将来如果有其它组件,都可以写到这个数组里

// 批量组件注册
const install = function (Vue) {
  // 判断是否安装
  if (install.installed) return

  // 遍历注册全局组件
  coms.forEach(component => {
    Vue.component(component.name, component)
  })

  // 判断是否是直接引入文件
  if (typeof window != 'undefined' && window.Vue) {
    install(window.Vue)
  }
};

export default {
  // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
  install,
  // 具体的组件
  wlWorkflow
}